module.exports = __webpack_public_path__ + "static/media/hatch_backdrop.fe632577.jpg";